import * as req from 'api/actions';
import * as c from './constant';

export const getTotalStats = (payload, callback) =>
  req.item(
    c.GET_TOTAL_STATS,
    'api/v1/administrators/e_wallet_services/statistics',
    payload,
    callback
  );

export const getGraphStats = (
  payload,
  callback
) =>
  req.list(
    c.GET_GRAPH_STATS,
    'api/v1/administrators/e_wallet_services/graph',
    payload,
    callback
  );

  export const getYearList = (
    payload,
    callback
  ) =>
    req.list(
      c.GET_YEAR_LIST,
      'api/v1/administrators/e_wallet_services/wallet_graph_year',
      payload,
      callback
    );